if (!customElements.get('gauze-addon-toggle')) {
  customElements.define(
    'gauze-addon-toggle',
    class GauzeAddonToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.gauze-addon__button');
        this.note = document.getElementById(`GauzeAddonNote-${this.dataset.sectionId}`);
        this.button?.addEventListener('click', this.toggle.bind(this));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data?.sectionId === this.dataset.sectionId) this.sync();
          });
        }

        this.sync();
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      get optionInputs() {
        const productInfo = this.closest('product-info');
        const inputs = productInfo?.querySelectorAll(
          'variant-selects input[data-option-name="Double-Layer Cotton Gauze"]'
        );

        return {
          no: Array.from(inputs || []).find((input) => input.value === 'No'),
          yes: Array.from(inputs || []).find((input) => input.value === 'Yes'),
        };
      }

      toggle() {
        const { no, yes } = this.optionInputs;
        const target = yes?.checked ? no : yes;
        if (!target) return;

        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      }

      sync() {
        const { no, yes } = this.optionInputs;
        const isSelected = Boolean(yes?.checked);
        const isReady = Boolean(no && yes);

        if (this.button) {
          this.button.disabled = !isReady;
          this.button.setAttribute('aria-pressed', String(isSelected));
        }

        if (this.note) this.note.hidden = !isSelected;
      }
    }
  );
}
